import { Component } from '@angular/core';

@Component({
    selector: 'app-application-index',
    templateUrl: './index.component.html',
    styleUrls: ['./application.component.scss']
})
export class IndexComponent { }
